module.exports = __webpack_public_path__ + "img/58_22.80fbaf11.png";